import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const NotesLiner24 = () => /*#__PURE__*/_jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    d: "M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14M22 10H18C15 10 14 9 14 6V2M22 10L14 2M7 13H13M7 17H11",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});